import { CONSTRAINT_FLAGS_DICT, VARIANTS_TYPES } from "../common/constants";

class GnomadEntry {
  constructor(data) {
    this.transcript = data?.transcript;
    this.transcriptType = data?.transcript_type;
    this.pli = data?.lof_hc_lc_pli;
    this.prec = data?.lof_hc_lc_prec;
    this.pnull = data?.lof_hc_lc_pnull;
    this.geneType = data?.gene_type;
    this.numCodingExons = data?.num_coding_exons;
    this.cdsLength = data?.cds_length;
    this.constraintFlags = (data?.constraint_flag || []).map((x) => ({
      flag: x,
      explanation: CONSTRAINT_FLAGS_DICT[x],
    }));
    this.variants = VARIANTS_TYPES.map((x) => {
      const { name, suffix } = x;
      const zScore = data?.[`${suffix}_z`];
      const observed = data?.[`obs_${suffix}`];
      const expected = data?.[`exp_${suffix}`];
      const observedExpected = data?.[`oe_${suffix}`];
      const observedExpectedLower = data?.[`oe_${suffix}_lower`];
      const observedExpectedUpper = data?.[`oe_${suffix}_upper`];
      const mutationRate = data?.[`mu_${suffix}`];
      const totalPossible = data?.[`possible_${suffix}`];
      return {
        name,
        zScore,
        observed,
        expected,
        observedExpected,
        observedExpectedLower,
        observedExpectedUpper,
        mutationRate,
        totalPossible,
      };
    });
  }
}

export default GnomadEntry;
